<template lang="pug">
.map-sidebar-sort-by.map-sidebar-list-utility
  AppSelectDropdown(
    v-model="selected"
    :options="options"
  )
    | Sort: {{ selected.text }}
    template(#option="{ option }")
      span.p-0(:class="iconClass(option)")
        | {{ option.text }}
</template>

<script>
export default {
  name: 'JobSitesSortBy',
  props: {
    label: {
      type: String,
      default: 'Sort by',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    selected: {
      get() {
        const id = this.$store.state.job_sites_group_by;

        return this.options.find((opt) => opt.id === id) || {};
      },
      set(selectedValue) {
        this.$store.dispatch('sortJobSites', { group_by: selectedValue.id });
      },
    },
  },
  methods: {
    iconClass(option) {
      const icon = option.icon ? option.icon : option.id;

      return `is-${icon}`;
    },
  },
};
</script>
